import { motion } from 'framer-motion'
import React from 'react'
import { FaCheckCircle } from 'react-icons/fa'
import styles from './Services.module.css'

const Services = () => {
    const services = [
        { title: "AI & Machine Learning Solutions", description: "Leverage AI and ML to enhance business processes, automate tasks, and gain predictive insights." },
        { title: "Data Analytics & Business Intelligence", description: "Transform raw data into actionable insights with advanced analytics and visualization tools." },
        { title: "Enterprise Software Development", description: "Custom-built software solutions for efficiency, including SaaS platforms and automation tools." },
        { title: "Digital Transformation Consulting", description: "Helping organizations embrace AI, cloud computing, and automation for digital transformation." },
        { title: "Cybersecurity & Risk Management", description: "Protect your business with advanced security solutions, compliance management, and risk assessments." },
    ];
    
    return (
        <div className={styles.container}>
            <motion.div className={styles.services} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1 }}>
                <h2 className={styles.sectionTitle}>Our Services</h2>
                <div className={styles.servicesGrid}>
                    {services.map((service, index) => (
                        <motion.div 
                            key={index} 
                            className={styles.serviceTile}
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: index * 0.2 }}
                            viewport={{ once: true }}
                        >
                            <div className={styles.icon}><FaCheckCircle /></div>
                            <h3>{service.title}</h3>
                            <p>{service.description}</p>
                        </motion.div>
                    ))}
                </div>
            </motion.div>
        </div>
    )
}

export default Services